<script setup lang="ts">

</script>

<template>
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_2687_1554" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="2" y="2" width="17" height="16">
      <path d="M17.5001 10.0001C17.5001 13.8662 14.3662 17.0002 10.5 17.0002H3.49994V10.0001C3.49994 6.13394 6.63388 3 10.5 3C14.3662 3 17.5001 6.13394 17.5001 10.0001Z" fill="white" stroke="white" stroke-width="1.40002" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6.99994 7.90002H13.3M6.99994 10.7001H13.3M6.99994 13.5001H10.5" stroke="black" stroke-width="1.40002" stroke-linecap="round" stroke-linejoin="round"/>
    </mask>
    <g mask="url(#mask0_2687_1554)">
      <path d="M2.09991 1.59998H18.9001V18.4002H2.09991V1.59998Z" fill="black"/>
    </g>
  </svg>
</template>

<style scoped lang="scss">

</style>